import React from 'react';
import CountdownBanner from '../../components/coraa-webinar/FixedCountdownBanner';
// Import components with relative paths to avoid module resolution issues
import HeroSection from '../../components/coraa-webinar/HeroSection';
import WebinarDetailsSection from '../../components/coraa-webinar/WebinarDetailsSection';
import LiveRevealAgenda from '../../components/coraa-webinar/LiveRevealAgenda';
import ChaosWithoutCoraa from '../../components/coraa-webinar/ChaosWithoutCoraa';
import WhyItMatters from '../../components/coraa-webinar/WhyItMatters';
import ThePanel from '../../components/coraa-webinar/ThePanel';

import PlatformSuperchargeSection from '../../components/coraa-landing/PlatformSuperchargeSection';
import NonprofitSupportSection from '../../components/coraa-landing/NonprofitSupportSection';
import CTASection from '../../components/coraa-webinar/CTASection';

const CoraaAIWebinar = () => {
  return (
    <div className="bg-black text-white min-h-screen">
      {/* Animated Background */}
      <div className="fixed inset-0 bg-gradient-to-br from-gray-900 via-black to-gray-900 -z-10" />
      <main className="relative z-10 pt-0 pb-0 min-h-0">
        {/* <CountdownBanner /> */}
        <HeroSection />
        <WhyItMatters />
        <ChaosWithoutCoraa />
        <WebinarDetailsSection />
        <LiveRevealAgenda />
        <ThePanel />

        <PlatformSuperchargeSection />
        <NonprofitSupportSection />
        <CTASection />
      </main>

      {/* Global styles for animations */}
      <style>{
        `
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0px); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        .glow {
          text-shadow: 0 0 10px rgba(74, 222, 128, 0.8);
        }
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
        `}
      </style>
    </div>
  );
};

export default CoraaAIWebinar;